export enum UserRoles {
    ADMIN = 'ADMIN',
    EMPLOYEE = 'EMPLOYEE',
    STAKEHOLDER = 'STAKEHOLDER ',
    FREELANCER = 'FREELANCER',
}
